import { Feature, features } from './shared/features';
import { UserTypes } from './shared/interfaces';
import { Permission, permissions } from './shared/permissions';

interface NavAttributes {
  [propName: string]: any;
}
interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}
interface NavBadge {
  text: string;
  variant: string;
}
interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  iconStyle?: object;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
  userTypes?: UserTypes[];
  permissions?: Permission[];
  features?: Feature[];
}

export const navItems: NavData[] = [
  {
    name: 'Organizations',
    url: '/organization',
    userTypes: [UserTypes.ADMIN],
    icon: 'icon-briefcase',
    permissions: [permissions.ORGANIZATION.READ],
  },
  {
    name: 'Brokers',
    url: '/broker',
    userTypes: [UserTypes.ADMIN],
    icon: 'icon-briefcase',
    permissions: [permissions.BROKER.READ],
  },
  {
    name: 'Customers',
    url: '/customer',
    userTypes: [UserTypes.ADMIN],
    icon: 'icon-people',
    permissions: [permissions.CUSTOMER.READ],
  },
  {
    name: 'Policies',
    icon: 'icon-docs',
    url: '/policy*',
    userTypes: [UserTypes.ADMIN],
    permissions: [permissions.POLICY.READ],
    children: [
      {
        name: 'Policy groups',
        url: '/policyGroup',
        icon: 'icon-docs',
        iconStyle: { 'font-size': '0.7rem', 'margin-left': '-20px' },
      },
      {
        name: 'Policies',
        url: '/policy',
        icon: 'icon-docs',
        iconStyle: { 'font-size': '0.7rem', 'margin-left': '-20px' },
      },
    ],
  },
  {
    name: 'Inspections',
    icon: 'fa fa-file-text-o',
    url: '/inspection',
    permissions: [permissions.INSPECTION.READ],
    children: [
      // Admin
      {
        name: 'Search',
        url: '/inspection/search',
        icon: 'fa fa-search',
        iconStyle: { color: 'white', 'font-size': '0.7rem', 'margin-left': '-20px' },
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.INSPECTION.READ],
      },
      {
        name: 'Flow',
        url: '/inspection/flow',
        icon: 'fa fa-circle',
        iconStyle: { color: 'white', 'font-size': '0.7rem', 'margin-left': '-20px' },
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.INSPECTION.READ],
      },
      {
        name: 'Waiting',
        url: '/inspection/waiting',
        icon: 'fa fa-circle',
        iconStyle: { color: '#f5a100', 'font-size': '0.7rem', 'margin-left': '-20px' },
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.INSPECTION.READ],
      },
      {
        name: 'Rejected',
        url: '/inspection/rejected',
        icon: 'fa fa-circle',
        iconStyle: { color: '#dc3e3e', 'font-size': '0.7rem', 'margin-left': '-20px' },
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.INSPECTION.READ],
      },
      {
        name: 'Accepted',
        url: '/inspection/accepted',
        icon: 'fa fa-circle',
        iconStyle: { color: '#17a6db', 'font-size': '0.7rem', 'margin-left': '-20px' },
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.INSPECTION.READ],
      },
      {
        name: 'Underwriting',
        url: '/inspection/underwriting',
        icon: 'fa fa-circle',
        iconStyle: { color: '#9e9e9e', 'font-size': '0.7rem', 'margin-left': '-20px' },
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.INSPECTION.READ],
      },
      {
        name: 'Sync',
        url: '/sync/list',
        icon: 'fa fa-circle',
        iconStyle: { color: '#ffd689', 'font-size': '0.7rem', 'margin-left': '-20px' },
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.INSPECTION.READ],
      },
      {
        name: 'Email events',
        url: '/inspection/emailEvent/list',
        icon: 'fa fa-circle',
        iconStyle: { color: '#8995ff', 'font-size': '0.7rem', 'margin-left': '-20px' },
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.SENDGRID_EVENT.READ],
      },

      // Vendor
      {
        name: 'Flow',
        url: '/inspection/vendor/flow',
        icon: 'fa fa-circle',
        iconStyle: { color: 'white', 'font-size': '0.7rem', 'margin-left': '-20px' },
        userTypes: [UserTypes.VENDOR],
      },
      {
        name: 'Accepted',
        url: '/inspection/accepted',
        icon: 'fa fa-circle',
        iconStyle: { color: '#17a6db', 'font-size': '0.7rem', 'margin-left': '-20px' },
        userTypes: [UserTypes.VENDOR],
      },
    ],
  },
  {
    name: 'Spatial Analysis',
    url: '/gis/one-map',
    icon: 'icon-location-pin',
    userTypes: [UserTypes.ADMIN],
    features: [features.GIS],
    children: [
      // {
      //   name: 'One Point',
      //   url: '/gis/one-point',
      //   permissions: [permissions.RISK.READ, permissions.FARM.READ],
      // },
      {
        name: 'All Intersections',
        url: '/gis/intersection',
        permissions: [permissions.RISK.READ, permissions.FARM.READ, permissions.INSTERSECTION.READ],
      },
      {
        name: 'One Map',
        url: '/gis/one-map',
        permissions: [permissions.RISK.READ, permissions.FARM.READ, permissions.INSTERSECTION.READ],
      },
      {
        name: 'Measurements',
        url: '/gis/measurement',
        permissions: [permissions.RISK.READ, permissions.FARM.READ, permissions.INSTERSECTION.READ],
      },
      {
        name: 'Export point',
        url: '/gis/export',
      },
      {
        name: 'PEX for Spectrum',
        url: '/gis/pex',
        permissions: [permissions.RISK.READ, permissions.FARM.READ],
      },
      {
        name: 'Upload CSV/XLS',
        url: '/gis/upload',
        permissions: [permissions.FARM.WRITE],
      },
    ],
  },
  {
    name: 'Vendors',
    url: '/vendor',
    icon: 'icon-home',
    userTypes: [UserTypes.ADMIN],
    permissions: [permissions.VENDOR.READ],
  },
  {
    name: 'Inspectors',
    url: '/inspector',
    icon: 'fa fa-user-o',
    userTypes: [UserTypes.ADMIN],
    permissions: [permissions.INSPECTOR.READ],
  },
  {
    name: 'Inspectors',
    url: '/inspector',
    userTypes: [UserTypes.VENDOR],
  },
  {
    name: 'Inspection Builder',
    userTypes: [UserTypes.ADMIN],
    permissions: [permissions.INSPECTION_ITEM.READ],
    icon: 'fa fa-comment-o',
    url: '/question',
    children: [
      {
        name: 'Insp. Versions',
        url: '/version',
        permissions: [permissions.INSPECTION_ITEM.READ],
        userTypes: [UserTypes.ADMIN],
      },
      {
        name: 'Questions',
        url: '/question/tree',
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.QUESTION.READ],
      },
      {
        name: 'Help Dump',
        url: '/question/help',
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.QUESTION.READ],
      },
      {
        name: 'Change log',
        url: '/inspection-builder-changelog',
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.QUESTION.READ],
      },
    ],
  },
  // {
  //   name: 'Help',
  //   userTypes: [UserTypes.ADMIN],
  //   permissions: [permissions.HELP_CATEGORY.READ],
  //   url: '/help',
  //   icon: 'icon-question',
  //   children: [
  //     {
  //       name: 'Categories',
  //       url: '/helpCategory/list',
  //       userTypes: [UserTypes.ADMIN],
  //       permissions: [permissions.HELP_CATEGORY.READ],
  //     },
  //     {
  //       name: 'Sections',
  //       url: '/helpSection/list',
  //       userTypes: [UserTypes.ADMIN],
  //       permissions: [permissions.HELP_SECTION.READ],
  //     },
  //     {
  //       name: 'Help Pages',
  //       url: '/help/tree',
  //       userTypes: [UserTypes.ADMIN],
  //       permissions: [permissions.HELP_PAGE.READ],
  //     },
  //   ],
  // },
  {
    name: 'Access Control',
    userTypes: [UserTypes.ADMIN],
    permissions: [permissions.ROLE.READ],
    url: '/role',
    icon: 'fa fa-key',
    children: [
      {
        name: 'Roles',
        url: '/role/list',
        permissions: [permissions.ROLE.READ],
      },
      {
        name: 'Admins',
        url: '/user/admins',
        permissions: [permissions.USER.READ],
      },
      {
        name: 'OTP',
        url: '/otp/list',
        permissions: [permissions.INSPECTOR.GENERATE_OTP],
      },
    ],
  },
  {
    name: 'Settings',
    url: '/setting*',
    userTypes: [UserTypes.ADMIN],
    icon: 'fa fa-cog',
    permissions: [permissions.CUSTOMER.READ],
    children: [
      {
        name: 'Auto Flags',
        url: '/flagGroupTag/tree',
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.QUESTION.WRITE],
      },
      {
        name: 'Onboarding',
        url: '/onboarding',
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.ONBOARDING.READ],
      },
      {
        name: 'System config',
        url: '/setting',
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.SETTING.READ],
      },
      {
        name: 'Product Types',
        url: '/product-type',
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.PRODUCT_TYPE.READ],
      },
      {
        name: 'Letter Blocks',
        url: '/letterBlock',
        userTypes: [UserTypes.ADMIN],
        permissions: [permissions.SETTING.READ],
      },
    ],
  },
  {
    name: 'Profile',
    url: '/vendor/profile',
    userTypes: [UserTypes.VENDOR],
  },
];
